module.exports = "<router-outlet></router-outlet>\n<!--app-header></app-header-->\n"